import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Dashboard/Header/Header';
import Sidebar from '../../components/Dashboard/Sidebar/Sidebar';
import Breadcrumbs from '../../components/Common/Breadcrumbs/Breadcrumbs';
import ProjectForm from './ProjectForm';
import styles from './CreateProject.module.css';
import toast from 'react-hot-toast';

const CreateProject = () => {
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleSave = (shouldAddAnother) => {
        if (!shouldAddAnother) {
            navigate('/projects');
        }
    };

    const handleCancel = () => {
        navigate('/projects');
    };

    return (
        <div className={styles['create-project-container']}>
            {isSidebarOpen && <div className={styles['sidebar-overlay']} onClick={() => setIsSidebarOpen(false)}></div>}
            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
            <div className={styles['content-wrapper']}>
                <Header onMenuClick={() => setIsSidebarOpen(true)} />
                <main className={styles['main-content']}>
                    <div className={styles['page-header']}>
                        <div className={styles['header-title-section']}>
                            <Breadcrumbs />
                            <h1>Add Project</h1>
                            <p>Initialize a new project with comprehensive tracking and team assignments.</p>
                        </div>
                    </div>
                    <div className={styles['form-container']}>
                        <ProjectForm onSave={handleSave} onCancel={handleCancel} />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default CreateProject;
